/*
 * TOPIAM Employee - Employee Identity and Access Management
 * Copyright © 2022-Present Jinan Yuanchuang Network Technology Co., Ltd. (support@topiam.cn)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export default {
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',
  'components.right_content.profile': '我的账户',
  'components.right_content.change-password': '修改密码',
  'components.right_content.logout': '退出登录',

  // excel import component
  'component.excel.import.input': '导入',
  'component.excel.import.notification.rule.0.message': '提示',
  'component.excel.import.success': '导入成功',
  'component.excel.import.fail': '导入失败',
  'component.excel.import.template.download': '模板下载',
  'component.excel.import.fail.data': '导入失败数据',
  'component.excel.import.template.prompt': '提示：仅允许导入“xls”或“xlsx”格式文件',
  'component.excel.import.only_single_file_can_be_uploaded': '只能上传单个文件',
  'component.excel.import.click_or_drag_files_to_the_area_to_upload':
    '单击或拖动文件到该区域以上传',
  'component.excel.import.whether_to_update_exist_data': '是否更新已经存有数据',
  'component.excel.import.not_exist_message': '请选择导入文件',
  'component.excel.import.problem_prompt':
    '当前导入成功{success}条数据，失败{failure}条数据，请修改错误数据后重新导入。',
  'component.excel.import.problem_row': '行',
  'component.excel.import.problem_column': '列',
  'component.excel.import.problem_reason': '原因',
  'component.right_content.about.title': '关于',
  'component.right_content.about.button': '检查更新',
  'component.right_content.about.button.remark': '在线升级未配置',
  'component.right_content.about.button.setting': '立即配置',
  'component.app_check_card.search.placeholder': '请输入应用名称',
  'component.org_transfer.search.placeholder': '输入组织名称或组织编码',
  'component.org_transfer': '组织架构',
};
